import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import { DuplicateIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { Button } from 'foundations-components/transitional/components/Button';
import { ButtonGroup } from 'foundations-components/transitional/components/ButtonGroup';
import { CopyButton } from 'foundations-components/transitional/components/CopyButton';
import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import { Toggle } from 'foundations-components/transitional/components/Toggle';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import AcademyCompanionButton from '../../interactiveEducation/components/AcademyCompanionButton';
import { useVideoPlayerConfig } from '../videoHooks';
import { HasGate } from '../../accounts/components/HasGate';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const VideoControls = ({
  additionalTracking,
  embedCode,
  enableAiCompanion = false,
  displayAICompanion,
  handleAICompanionDisplay,
  onFinish,
  onToggleAutoPlay
}) => {
  const {
    autoPlay,
    toggleAutoPlay
  } = useVideoPlayerConfig();
  const {
    isNotLaptop
  } = useMediaQuery();
  const handleChangeAutoplay = () => {
    toggleAutoPlay();
    if (onToggleAutoPlay) {
      onToggleAutoPlay();
    }
  };
  const handleAICompanionClick = () => handleAICompanionDisplay && handleAICompanionDisplay(!displayAICompanion);
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    borderEndEndRadius: "100",
    borderEndStartRadius: "100",
    flexDirection: "row",
    flexWrap: "nowrap",
    justifyContent: "center",
    children: [/*#__PURE__*/_jsx(Flex, {
      inlineSize: "100%",
      children: /*#__PURE__*/_jsxs(FormLabel, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.videoControls.autoPlay"
        }), /*#__PURE__*/_jsx(Toggle, {
          checked: autoPlay,
          id: "toggle-button",
          marginInlineStart: "300",
          onChange: handleChangeAutoplay,
          size: "extra-small"
        })]
      })
    }), isNotLaptop && enableAiCompanion && /*#__PURE__*/_jsx(Flex, {
      inlineSize: "50%",
      justifyContent: "center",
      children: /*#__PURE__*/_jsx(HasGate, {
        gate: "Academy:InteractiveEducation",
        children: /*#__PURE__*/_jsx(AcademyCompanionButton, {
          additionalTracking: additionalTracking,
          displayAICompanion: !!displayAICompanion,
          handleAICompanionClick: handleAICompanionClick
        })
      })
    }), /*#__PURE__*/_jsx(Flex, {
      inlineSize: "100%",
      justifyContent: "end",
      children: /*#__PURE__*/_jsxs(ButtonGroup, {
        children: [embedCode && /*#__PURE__*/_jsxs(CopyButton, {
          hint: I18n.text('learningCenter.videoControls.copyEmbedHint'),
          hintSuccess: I18n.text('learningCenter.videoControls.copyEmbedSuccess'),
          value: embedCode,
          children: [/*#__PURE__*/_jsx(DuplicateIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.videoControls.copyEmbedCode"
          })]
        }), !!onFinish && /*#__PURE__*/_jsx(Button, {
          onClick: onFinish,
          use: "secondary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.common.next"
          })
        })]
      })
    })]
  });
};
export default VideoControls;